export default __webpack_public_path__ + "static/media/circuit.6e2efa2a.png";